import React, { useEffect, useState } from "react";
import VLILogo from "./Assets/VLICheckoutLogo.png";
import { useDispatch, useSelector } from "react-redux";
import { PaypalBtn } from "../CourseEnrollment/Payment/Components/PaypalPayment/PaypalPayment";
import Paypal from "./Assets/paypalPaymentimg.png";
import CreditCard from "./Assets/CreditCardMethod.svg";
import BankTransfer from "./Assets/BankTransferMethod.svg";
import { useParams } from "react-router-dom";
import packagesData from "../../JsonFiles/InstitutePackages.json";
import DoneIcon from '@mui/icons-material/Done';
import ReCAPTCHA from "react-google-recaptcha-v2";
import { useAuthContext } from "../../context/authContext";
import { PaypalCheckoutBtn } from "./PaypalCheckoutBtn";
import ReactDOM from "react-dom";
import axios from 'axios';
import { Elements, useStripe, useElements, CardElement, PaymentElement, PaymentRequestButtonElement } from "@stripe/react-stripe-js";
import { BaseUrl } from "../../Actions/Base";
import dayjs from "dayjs";
import { CheckoutPaymentFailureA, CheckoutPaymentSuccessA } from "../../Actions/UserA";
import errorMessageImage from "./Assets/errorMessage.png";
import ReuseablePopup from "../../Components/ReuseablePopups/ReuseablePopup";

const PaymentCheckout = ({setOpenSignupScreen, InstituteData, setInstituteData, handleSubmit, InstitutePackagesData}) => {
    const Border = "border-[#E2E2E2] border-[1px] border-solid";
    const [selectedPaymentMethod, setSelectedPaymentMethod] = useState("");
    const [selectedPackage, setSelectedPackage] = useState("");
    const [errors, setErrors] = useState({});
    const [promoCode, setPromoCode] = useState("");
    const [promoMessage, setPromoMessage] = useState(""); // for success/error message
    const [promoSuccessMessage, setPromoSuccessMessage] = useState(""); // for success/error message
    const [discountPercentage, setDiscountPercentage] = useState(null);
    const [discount, setDiscount] = useState(null);
    const [renewalDate, setRenewalDate] = useState("");

    const dispatch = useDispatch();
    const { packageId, instituteId } = useParams(); // Get packageId from the URL
    const stripe = useStripe();
    const elements = useElements();

    const [error, setError] = useState("");
    const [paymentSuccess, setPaymentSuccess] = useState(false);
    const [loading, setLoading] = useState(false);

    const PayPalButton = window.paypal?.Buttons?.driver("react", {
        React,
        ReactDOM,
    });

    // const handlePaymentMethodChange = (e) => {
    //     const selectedMethod = e.target.value;
      
    //     setSelectedPaymentMethod(selectedMethod); // for local conditional UI (like showing PayPal component)
      
    //     setInstituteData((prevData) => ({
    //       ...prevData,
    //       paymentInfo: {
    //         ...prevData.paymentInfo,
    //         paymentMethod: selectedMethod, // update in main form state
    //       },
    //     }));
    //   };

    const selectedPackageData = InstitutePackagesData.find(
        (pkg) => pkg.PackageId === InstituteData.package.id
      );

    const [discountedPrice, setDiscountedPrice] = useState(selectedPackageData.price);
    const [isUpdationFailedPopup, setIsUpdationFailedPopup] = useState(false);
    const [errorMessageText, setErrorMessageText] = useState("Something Went Wrong");

    const cleanNumber = (value) => {
        if (!value) return 0;
        // Remove $ and % and any extra spaces, then parse
        return parseFloat(String(value).replace(/[$,%\s]/g, ""));
      };
      
      const price = cleanNumber(selectedPackageData?.price);
      const annualPrice = cleanNumber(selectedPackageData?.AnnualPrice);

      const activation = cleanNumber(selectedPackageData?.activationCharges);
      const discountPercent = cleanNumber(selectedPackageData?.totalDiscount);
      
      const subTotal = price + activation;
      const subAnnualTotal = annualPrice + activation;

      const discountedTotal = subTotal * (1 - discountPercent / 100);
      const discountedAnnualTotal = subAnnualTotal * (1 - discountPercent / 100);

      const tax = discountedTotal * 0.13;
      const taxAnnual = discountedAnnualTotal * 0.13;

      const grandTotal = discountedTotal + tax;  
      const grandAnnualTotal = discountedAnnualTotal + taxAnnual; 
      
      const TotalPriceToCharge = InstituteData?.package?.PackageType === "Monthly"
      ? `$${grandTotal.toFixed(2)}`
      : `$${grandAnnualTotal.toFixed(2)}`

      
      useEffect(() => {
        
        // Update TotalPriceToCharge in InstituteData.paymentInfo
        setInstituteData(prev => ({
          ...prev,
          paymentInfo: {
            ...prev.paymentInfo,
            TotalPriceToCharge
          }
        }));
      }, [TotalPriceToCharge]);
      
    useEffect(() => {
    if (InstituteData.package.id) {
        setSelectedPackage(InstituteData.package.id);
    }
    }, [InstituteData.package.id]);

    const { captcha, setCaptcha } = useAuthContext();

    function onChange(value) {
    setCaptcha(value);
    }

    const handlePaymentInputChange = (e) => {
        const { name, value } = e.target;
        setInstituteData((prevData) => ({
          ...prevData,
          paymentInfo: {
            ...prevData.paymentInfo,
            [name]: value,
          },
        }));
      };

    const handlePaymentMethodChange = (e) => {
    const selectedMethod = e.target.value;
    
    // Temporarily set the selected payment method to perform validation
    setInstituteData((prevData) => ({
        ...prevData,
        paymentInfo: {
        ...prevData.paymentInfo,
        paymentMethod: selectedMethod,
        },
    }));
    
    // Perform validation
    const isValid = validateFields();
    
    if (isValid) {
        // If validation passes, update the selected payment method
        setSelectedPaymentMethod(selectedMethod);
    } else {
        // If validation fails, reset the payment method
        // setInstituteData((prevData) => ({
        // ...prevData,
        // paymentInfo: {
        //     ...prevData.paymentInfo,
        //     paymentMethod: '',
        // },
        // }));
        setSelectedPaymentMethod('');
    }
    };
      
      const handleAgreementChange = (e) => {
        setInstituteData((prevData) => ({
          ...prevData,
          paymentInfo: {
            ...prevData.paymentInfo,
            agreedToTerms: e.target.checked,
          },
        }));
      };

      const handleAutoDeductionChange = (e) => {
        setInstituteData((prevData) => ({
          ...prevData,
          paymentInfo: {
            ...prevData.paymentInfo,
            autoDeduction: e.target.checked,
          },
        }));
      };

      const validateFields = () => {
        const newErrors = {};
        const { paymentInfo } = InstituteData;
    
        // Payment Info Validations
        // if (!paymentInfo.paymentMethod) newErrors.paymentMethod = "Select a payment method";
        // if (!paymentInfo.paymentSuccessful) newErrors.paymentSuccessful = "Payment not confirmed";
        if (!paymentInfo.agreedToTerms) newErrors.agreedToTerms = "Please agree to terms";
        if (!paymentInfo.autoDeduction) newErrors.autoDeduction = "Please check the input";

        // Captcha validation
        if (!captcha) newErrors.captcha = "Captcha not verified";
    
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleApplyPromoCode = async () => {
        setPromoMessage("")
        setPromoSuccessMessage("")
        if (!promoCode) {
          setPromoMessage("Please enter a promo code.");
          return;
        }
      
        try {
          const res = await axios.post("/api/applyPromoCode", {
            instituteId,
            promoCode,
          });
          console.log("response is:",res)
          if (res.status === 200) {
            const discount = res.data.discount;
            // Apply discount to price
            const discountValue = parseFloat(discount.replace('%', '')); // Remove the '%' and convert to number
            const originalPrice = parseFloat(selectedPackageData.price.replace('$', '').trim()); // Get the number part of price
            setDiscount(originalPrice * (discountValue / 100))
            const newPrice = originalPrice - (originalPrice * (discountValue / 100)); // Calculate new price
            setDiscountedPrice(newPrice.toFixed(2)); // Set the discounted price, round to 2 decimal places
            setPromoSuccessMessage(`Promo code applied! Discount: ${discount}`);
          } else {
            setPromoMessage(res.data.message || "Promo code is not valid.");
          }
        } catch (err) {
          // Check if there is a response object in the error
            if (err.response) {
                // Set the error message from the backend if available
                setPromoMessage(err.response.data.message || "Something went wrong. Please try again.");
            } else {
                // If no response object, fall back to a general error message
                setPromoMessage("Something went wrong. Please try again.");
            }
            console.error(err);
            }
      };

      const handleCardPaymentSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
    
        try {
            // Construct updatedPaymentInfo right away if needed
            const CreditCardDetails = {
                brand: "",
                exp_month: "",
                exp_year: "",
                last4: "",
                postal_code: ""
            };
    
            const updatedPaymentInfo = {
                ...InstituteData.paymentInfo,
                cardDetails: CreditCardDetails,
                grandTotal: TotalPriceToCharge
            };

             // 🔄 Proceed with Stripe after handleSubmit finishes
             if (!stripe || !elements) {
                setError("Stripe is not properly initialized.");
                setLoading(false);
                return;
            }

            const { error, paymentMethod } = await stripe.createPaymentMethod({
                type: "card",
                card: elements.getElement(CardElement),
            });
    
            if (error) {
                setError(error.message);
                setLoading(false);
                return;
            }
            console.log("paymentMethod:",paymentMethod);

            const TotalFee = TotalPriceToCharge;
    
            // ✅ Call handleSubmit first (before Stripe logic)
            await handleSubmit(updatedPaymentInfo);
            console.log("✅ handleSubmit finished");

           
            console.log("⚡ Proceeding to create payment method");

    
            const response = await fetch(`${BaseUrl}/api/stripecardpayment`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ paymentMethodId: paymentMethod.id, TotalFee }),
            });
    
            const data = await response.json();
            console.log("data of card payment is:",data)

            if (data.error) {
                // setError(data.error);
                setError(JSON.stringify(data.error));
                dispatch(CheckoutPaymentFailureA(data.error, instituteId));
                setLoading(false);
                return;
            }
    
            const finalCardDetails = {
                CardBrand: data.card.brand,
                CardExpMonth: data.card.exp_month,
                CardExpYear: data.card.exp_year,
                CardLast4: data.card.last4,
                CardPostalCode: data.card?.postal_code,
                paymentType:"creditcard"
            };
    
            const { paymentIntent, error: confirmError } = await stripe.confirmCardPayment(
                data.clientSecret
            );

            console.log("confirmError:",confirmError)
            if (confirmError) {
                dispatch(CheckoutPaymentFailureA(confirmError.message, instituteId));
                setError(confirmError.message);
            } else if (paymentIntent.status === "succeeded") {
                setPaymentSuccess(true);
                dispatch(CheckoutPaymentSuccessA(finalCardDetails, instituteId,
                    () => {
                        console.log("Institute Registered Successfully!");
                        setOpenSignupScreen("SubmissionScreen");
                    },
                    (errorMessage) => {
                        // alert(errorMessage); // show error
                        setErrorMessageText(errorMessage)
                        setIsUpdationFailedPopup(true)
                    }
                ));
            }
        } catch (submitError) {
            setError(submitError.message || "Error submitting form.");
        }
    
        setLoading(false);
    };
    

    // const handleCardPaymentSubmit = async (e) => {
    //     e.preventDefault();
    //     setLoading(true);

    //     if (!stripe || !elements) {
    //         setError("Stripe is not properly initialized.");
    //         setLoading(false);
    //         return;
    //     }

    //     const { error, paymentMethod } = await stripe.createPaymentMethod({
    //         type: "card",
    //         card: elements.getElement(CardElement),
    //     });

    //     if (error) {
    //         setError(error.message);
    //         setLoading(false);
    //         return;
    //     }
    //     console.log("grandTotal in function is:",grandTotal)
    //      const TotalFee = grandTotal;
    //     // const TotalFee = parseFloat(grandTotal.replace('$', ''));

    //     // Send the payment method ID to the backend
    //     const response = await fetch(`${BaseUrl}/api/stripecardpayment`, {
    //         method: "POST",
    //         headers: { "Content-Type": "application/json" },
    //         body: JSON.stringify({ paymentMethodId: paymentMethod.id, TotalFee }),
    //     });

    //     const data = await response.json();
    //     console.log("data of card payment is:",data)

    //     const CreditCardDetails = {
    //         brand: data.card.brand,
    //         exp_month: data.card.exp_month,
    //         exp_year: data.card.exp_year,
    //         last4: data.card.last4,
    //         postal_code: data.card?.postal_code,
    //     };
    //     console.log("CreditCardDetails of card payment is:",CreditCardDetails)

    //     if (data.error) {
    //         setError(data.error);
    //         setLoading(false);
    //         return;
    //     }

    //     // Confirm the payment
    //     const { paymentIntent, error: confirmError } = await stripe.confirmCardPayment(
    //         data.clientSecret
    //     );

    //     if (confirmError) {
    //         setError(confirmError.message);
    //     } else if (paymentIntent.status === "succeeded") {
    //         setPaymentSuccess(true);

    //          // ✅ Update InstituteData with card details and payment info
    //         // setInstituteData(prev => ({
    //         //     ...prev,
    //         //     paymentInfo: {
    //         //         ...prev.paymentInfo,
    //         //         paymentSuccessful: true,
    //         //         cardDetails: {
    //         //             CardBrand: CreditCardDetails.brand,
    //         //             CardExpMonth: CreditCardDetails.exp_month,
    //         //             CardExpYear: CreditCardDetails.exp_year,
    //         //             CardLast4: CreditCardDetails.last4,
    //         //             CardPostalCode:  CreditCardDetails.postal_code
    //         //         },
    //         //     }
    //         // }));


    //         // ✅ Construct updated paymentInfo inline
    //         const updatedPaymentInfo = {
    //             ...InstituteData.paymentInfo,
    //             paymentSuccessful: true,
    //             cardDetails: {
    //                 CardBrand: CreditCardDetails.brand,
    //                 CardExpMonth: CreditCardDetails.exp_month,
    //                 CardExpYear: CreditCardDetails.exp_year,
    //                 CardLast4: CreditCardDetails.last4,
    //                 CardPostalCode: CreditCardDetails.postal_code
    //             }
    //         };

    //         handleSubmit(updatedPaymentInfo);
    //     }

    //     setLoading(false);
    // };


    useEffect(() => {
    if (!InstituteData?.package?.PackageType) return;

    const now = new Date();
    const packageType = InstituteData.package.PackageType?.toLowerCase(); // 'monthly' or 'yearly'

    let calculatedDate;

    if (packageType === "monthly") {
        calculatedDate = new Date(now.setMonth(now.getMonth() + 1));
    } else if (packageType === "yearly") {
        calculatedDate = new Date(now.setFullYear(now.getFullYear() + 1));
    }

    if (calculatedDate) {
        setRenewalDate(calculatedDate.toLocaleDateString()); // You can format as needed
    }
    }, [InstituteData.package.PackageType]);

        
return(
    <div className="w-[100%] py-[20px] pl-[30px] pr-[20px] lg:pl-[50px] lg:pr-[50px] flex flex-col gap-[10px]">
        <p className=" w-full text-[60px] font-bold text-center">
            Checkout
        </p>
        <p className=" w-full text-[26px] text-center">
            Please input all the required details to buy this plan.
        </p>

        <div className="w-full flex flex-col justify-center bg-[#FFFFFF] p-[30px] rounded-[34px] gap-[40px] mt-[40px]"
            style={{
                border:"1px solid #CCCCCC"
            }}>
            <div className="w-full flex justify-center">
                <img src={VLILogo} alt="" className="h-[40px]" />
            </div>

            <div className="w-full lg:hidden flex flex-col gap-[20px]">
                {selectedPackageData && (
                    <div
                    key={selectedPackageData.PackageId}
                    className={`w-[350px] h-[870px] lg:h-[800px] rounded-[20px] pl-[30px] pt-[10px] pr-[30px] flex flex-col gap-[15px] ${
                        selectedPackage === selectedPackageData.PackageId
                        ? `bg-[${selectedPackageData.bgColor}] text-[${selectedPackageData.textColor}]`
                        : `bg-[${selectedPackageData.bgColor}] text-[${selectedPackageData.textColor}]`
                    }`}
                    style={{ border: "1px solid #BCBCBC" }}
                    >
                     {/* Pricing */}
                     <div className="w-full flex flex-col gap-[10px] mt-[10px]">
                        <div className="w-full flex items-center gap-[15px]">
                            <p
                            className={`text-[20px] font-semibold relative before:content-[''] before:absolute before:top-1/2 before:left-0 before:w-full before:h-[2px] before:-translate-y-1/2 ${
                                selectedPackage === selectedPackageData.PackageId
                                ? `text-[${selectedPackageData.bgColorSelected}] before:bg-[${selectedPackageData.bgColorSelected}]`
                                : `text-[${selectedPackageData.bgColorSelected}] before:bg-[${selectedPackageData.bgColorSelected}]`
                            }`}
                            >
                            {/* {selectedPackageData.originalPrice} */}
                            {InstituteData.package.PackageType === "Monthly" ? selectedPackageData.originalPrice : selectedPackageData.originalAnnualPrice} 
                            </p>
                            <p className="text-[18px] font-semibold">
                            {/* {selectedPackageData.annualDiscount} */}
                            {InstituteData.package.PackageType === "Monthly" ? selectedPackageData.monthlyDiscount : selectedPackageData.annualDiscount} 
                            </p>
                        </div>
                        <p
                            className={`text-[40px] font-semibold ${
                                selectedPackage === selectedPackageData.PackageId
                                ? `text-[${selectedPackageData.bgColorSelected}]`
                                : `text-[${selectedPackageData.bgColorSelected}]`
                            }`}
                            >
                            {/* {selectedPackageData.price} */}
                            {InstituteData.package.PackageType === "Monthly" ? selectedPackageData.price : selectedPackageData.AnnualPrice} 
                            </p>
                    </div>
                    
                    {/* Header */}
                    <div className="flex items-center gap-[20px]">
                        {/* <img
                        src={
                            selectedPackage === selectedPackageData.PackageId
                            ? selectedPackageData.image
                            : selectedPackageData.image
                        }
                        alt={selectedPackageData.InstitutePackageName}
                        /> */}
                         <img
                        src={selectedPackage === selectedPackageData.PackageId ? `${BaseUrl}/api/images/InstitutePackages?url=${selectedPackageData.image}` : `${BaseUrl}/api/images/InstitutePackages?url=${selectedPackageData.image}`}
                        alt={selectedPackageData.InstitutePackageName}
                        />
                        <p className="text-[40px] lg:text-[50px] font-semibold leading-[50px]">
                        {selectedPackageData.InstitutePackageName}
                        </p>
                    </div>

                    {/* Features */}
                    {selectedPackageData.features.map((feature, index) => (
                        <div
                        key={index}
                        className="flex items-center gap-[20px] mt-[10px]"
                        >
                        <div
                            className={`w-[30px] h-[30px] rounded-full flex justify-center items-center`}
                            style={{ backgroundColor: selectedPackageData.checkBoxBg }}
                        >
                            <DoneIcon
                            color="inherit"
                            style={{ color: selectedPackageData.checkBoxTick }}
                            />
                        </div>
                        <p
                            className={`text-[18px] font-semibold }`}
                        >
                            {feature}
                        </p>
                        </div>
                    ))}

                   <div className="w-full flex justify-between">
                        <p className="text-[22px] font-semibold">Compensation Performance :</p>
                        <p className="text-[22px] font-semibold">15%</p>
                   </div>

                   <div className="w-full flex justify-between">
                        <p className="text-[22px] font-semibold">Package Renewal Date:</p>
                        <p className="text-[22px] font-semibold">{renewalDate || "N/A"}</p>
                   </div>

                    </div>
                )}
            </div>

            <div className="w-full flex justify-center gap-[40px]">
                <div className="w-full lg:w-[50%] 2.5xl:w-[60%] px-[30px] flex flex-col gap-[15px]">
                
                    <p className="text-[22px] text-[#000000] font-semibold mt-[10px]">Order Summary</p>

                    <div className="w-full flex flex-col gap-[10px] px-[20px] py-[15px] bg-[#F7F7F7] rounded-[10px] shadow-[4px_5px_6px_#00000029]"
                    style={{
                                border: "1px solid #707070"
                            }}>
                            <p className="text-[18px]"
                            >Premium - {InstituteData.package.PackageType === "Monthly" ? "Monthly" : "Annual"}  plan details.
                            </p>
                             <div className="w-full flex gap-[20px] justify-between py-[10px] px-[15px] bg-[#E0E0E0]">
                                    <p className="text-[15px] font-bold">Original Price</p>
                                    <p className="text-[15px] ">
                                    {InstituteData.package.PackageType === "Monthly"
                                        ? `$${price.toFixed(2)}`
                                        : `$${annualPrice.toFixed(2)}`}                                
                                    <sup>+Tax</sup></p>
                             </div>
                             <div className="w-full flex gap-[20px] justify-between px-[15px] ">
                                    <p className="text-[15px] font-bold">Activation Charges</p>
                                    <p className="text-[15px] ">
                                    ${activation.toFixed(2)}
                                    <sup>+Tax</sup></p>
                             </div> 
                             <div className="w-full flex gap-[20px] justify-between py-[10px] px-[15px] bg-[#E0E0E0]">
                                    <p className="text-[15px] font-bold">Sub Total</p>
                                    <p className="text-[15px] ">
                                    {/* ${subTotal.toFixed(2)} */}
                                    {InstituteData.package.PackageType === "Monthly"
                                        ? `$${subTotal.toFixed(2)}`
                                        : `$${subAnnualTotal.toFixed(2)}`}
                                    <sup>+Tax</sup></p>
                             </div> 
                             <div className="w-full flex gap-[20px] justify-between px-[15px] ">
                                    <p className="text-[15px] font-bold">Discount</p>
                                    <p className="text-[15px] ">
                                        {discountPercent}% 
                                    </p>
                             </div> 
                             <div className="w-full flex gap-[20px] justify-between py-[10px] px-[15px] bg-[#E0E0E0]">
                                    <p className="text-[15px] font-bold">Discounted Total:</p>
                                    <p className="text-[15px] ">
                                    {/* ${discountedTotal.toFixed(2)} */}
                                    {InstituteData.package.PackageType === "Monthly"
                                        ? `$${discountedTotal.toFixed(2)}`
                                        : `$${discountedAnnualTotal.toFixed(2)}`}
                                    <sup>+Tax</sup></p>
                             </div> 
                             <div className="w-full flex gap-[20px] justify-between px-[15px]">
                                    <p className="text-[15px] font-bold">Tax 13%</p>
                                    <p className="text-[15px] ">
                                    {/* ${tax.toFixed(2)} */}
                                    {InstituteData.package.PackageType === "Monthly"
                                        ? `$${tax.toFixed(2)}`
                                        : `$${taxAnnual.toFixed(2)}`}
                                    </p>
                             </div> 
                             <div className="w-full flex gap-[20px] justify-end py-[10px] px-[15px] bg-[#E0E0E0]">
                                    <p className="text-[22px] font-bold">Grand Total: </p>
                                    <p className="text-[22px] font-bold">
                                    {/* ${grandTotal.toFixed(2)} */}
                                    {InstituteData.package.PackageType === "Monthly"
                                        ? `$${grandTotal.toFixed(2)}`
                                        : `$${grandAnnualTotal.toFixed(2)}`}
                                    </p>
                             </div>
                           {/* Table with price breakdown */}
                            {/* <table className="w-full text-left text-[16px] border-t border-[#707070]">
                                <thead >
                                <tr style={{
                                borderBlock: "0.5px solid #707070"
                            }}>
                                    <th className="py-1 pr-4">Original Price</th>
                                    <th className="py-1 pr-4">Activation Charges</th>
                                    <th className="py-1 pr-4">Sub Total</th>
                                    <th className="py-1">Discount</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr>
                                    <td className="py-1 pr-4">$5000</td>
                                    <td className="py-1 pr-4">$500</td>
                                    <td className="py-1 pr-4">$5500</td>
                                    <td className="py-1 text-green-600">50%</td>
                                </tr>
                                </tbody>
                            </table> */}

                            {/* <div className="w-full flex flex-col justify-end gap-[10px]">
                                <div className="w-full flex gap-[20px] justify-end">
                                    <p className="text-[15px] font-bold">Discounted Total:</p>
                                    <p className="text-[15px] ">$1175<sup>+Tax</sup></p>
                                </div>

                                <div className="w-full flex gap-[20px] justify-end">
                                    <p className="text-[15px] font-bold">Tax 13%</p>
                                    <p className="text-[15px] ">$152.75</p>
                                </div>

                                <div className="w-full flex gap-[20px] mt-[10px] justify-end">
                                    <p className="text-[22px] font-bold">Grand Total: </p>
                                    <p className="text-[22px] font-bold">$1327.75</p>
                                </div>
                            </div> */}
                    </div>

                    {errors.captcha && <span className="text-[#FF0000]"> {errors.captcha}</span>}
                    <div className="w-full mt-[10px]">
                        <ReCAPTCHA
                            sitekey="6Lecb_IoAAAAANjflXMmXPZiBMaU0clxSmxPG9f9"
                            onChange={onChange}
                        />
                    </div>

                    <p className="text-[16px] text-[#404040] mt-[15px]">By registering this program, you consent to being contacted by Vehicle Learning Innovation (VLI) and/or Meliorist via email, SMS, or phone call regarding this content and other topics relevant to your interests. You may withdraw your consent at any time by clicking the "unsubscribe" link in any email or by contacting us directly, as outlined in our Privacy Policy.</p>
                    
                    {errors.agreedToTerms && <span className="text-[#FF0000]"> {errors.agreedToTerms}</span>}
                    <div className="w-full flex items-center gap-[15px]">
                        <input
                            type="checkbox"
                            checked={InstituteData.paymentInfo.agreedToTerms}
                            onChange={handleAgreementChange}
                            className="w-[15px] h-[15px] cursor-pointer mt-[3px]"
                        />
                        <p className="text-[18px] text-[#52A9FF]">I Agree to the above terms</p>
                    </div>
                        
                        <p className="text-[22px] text-[#000000] font-semibold ">Payment Method</p>
                        
                        {errors.paymentMethod && <span className="text-[#FF0000]"> {errors.paymentMethod}</span>}
                        {errors.paymentSuccessful && <span className="text-[#FF0000]"> {errors.paymentSuccessful}</span>}

                        <div className="w-full flex flex-col gap-[15px] px-[15px] py-[10px] bg-[#FFFFFF] rounded-[8px] shadow-[4px_5px_6px_#00000029] overflow-hidden"
                            style={{border:"1px solid #E8E8E8"}}>
                            <div className="w-full flex items-center justify-between">
                                <div>
                                    <input
                                        type="radio"
                                        id="paypal"
                                        name="paymentMethod"
                                        value="paypal"
                                        onChange={handlePaymentMethodChange}
                                        className="mr-2"
                                    />
                                    <label htmlFor="paypal" className="text-[18px] text-[#707070]">
                                        PayPal
                                    </label>
                                </div>
                                <div>
                                    <img src={Paypal} alt="Paypal" className="h-[30px] w-[100px] object-contain" />
                                </div>
                            </div>
                            {selectedPaymentMethod === "paypal" && (
                                <div className="w-full flex justify-center items-center">
                                    <div className="w-[50%]">
                                        <PaypalCheckoutBtn
                                            PayPalButton={PayPalButton}
                                            currency="USD"
                                            dispatch={dispatch}
                                            Package={TotalPriceToCharge}
                                            // Package={selectedPackageData.price}
                                            setInstituteData={setInstituteData}
                                            discount={discount}
                                            InstituteData={InstituteData}
                                            handleSubmit={handleSubmit}
                                            instituteId={instituteId}
                                            setOpenSignupScreen={setOpenSignupScreen}
                                        /> 
                                    </div>
                                </div>
                            )}
                        </div>

                        <div className="w-full flex flex-col px-[15px] py-[15px] bg-[#FFFFFF] rounded-[8px] shadow-[4px_5px_6px_#00000029]"
                            style={{border:"1px solid #E8E8E8"}}>
                            <div className="w-full flex items-center justify-between">
                                <div>
                                    <input
                                        type="radio"
                                        id="creditcard"
                                        name="paymentMethod"
                                        value="creditcard"
                                        onChange={handlePaymentMethodChange}
                                        className="mr-2"
                                    />
                                    <label htmlFor="Credit Card" className="text-[18px] text-[#707070]">
                                    Credit Card / Debit Card
                                    </label>
                                </div>
                                <div>
                                    <img src={CreditCard} alt="CreditCard" />
                                </div>
                            </div>

                            {selectedPaymentMethod === "creditcard" && (
                                <div className="mt-[10px] ">
                                    <CardElement
                                        options={{
                                            style: {
                                                base: {
                                                    fontSize: "18px",
                                                    padding: "10px",
                                                    color: "#424770",
                                                    backgroundColor: "white",
                                                    "::placeholder": { color: "#aab7c4" },
                                                },
                                                invalid: { color: "#9e2146" },
                                            },
                                        }}
                                    />
                                    <div className="w-full flex justify-end">
                                        <button disabled={!stripe} className="bg-[#A1A3EF] p-3" style={{ marginTop: "10px" }} onClick={handleCardPaymentSubmit}>
                                            {loading ? "Processing..." : `Pay ${TotalPriceToCharge}`}
                                        </button>
                                        
                                    </div>
                                </div>
                            )}
                        </div>

                        {error && <p style={{ color: "red" }}>{error}</p>}
                        {paymentSuccess && <p style={{ color: "green" }}>Payment successful!</p>}

                        <div className="w-full flex flex-col px-[15px] py-[15px] bg-[#FFFFFF] rounded-[8px] shadow-[4px_5px_6px_#00000029]"
                            style={{border:"1px solid #E8E8E8"}}>
                            <div className="w-full flex items-center justify-between">
                                <div>
                                    <input
                                        type="radio"
                                        id="BankAccount"
                                        name="paymentMethod"
                                        value="BankAccount"
                                        onChange={handlePaymentMethodChange}
                                        className="mr-2"
                                    />
                                    <label htmlFor="Bank Account" className="text-[18px] text-[#707070]">
                                        Bank Account
                                    </label>
                                </div>
                                <div>
                                    <img src={BankTransfer} alt="BankTransfer" className="h-[30px]" />
                                </div>
                            </div>
                            {selectedPaymentMethod === "BankAccount" && (
                                <div className="mt-[10px] flex flex-col gap-[10px]">
                                    <input
                                        type="text"
                                        placeholder="Bank Name"
                                        // value={paymentData.BankAccount.bankName}
                                        // onChange={(e) =>
                                        //     handleInputChange("BankAccount", "bankName", e.target.value)
                                        // }
                                        className={`w-full rounded-md text-[18px] py-2  px-[10px] ${Border} shadow-[4px_5px_6px_#00000029] `}
                                    />
                                    <input
                                        type="text"
                                        placeholder="Account Holder's Name"
                                        // value={paymentData.BankAccount.accountHolderName}
                                        // onChange={(e) =>
                                        //     handleInputChange("BankAccount", "accountHolderName", e.target.value)
                                        // }
                                        className={`w-full rounded-md text-[18px] py-2  px-[10px] ${Border} shadow-[4px_5px_6px_#00000029] `}
                                    />
                                    <div className="flex gap-[20px]">
                                        <input
                                            type="text"
                                            placeholder="Bank/Institute Code"
                                            // value={paymentData.BankAccount.bankCode}
                                            // onChange={(e) =>
                                            //     handleInputChange("BankAccount", "bankCode", e.target.value)
                                            // }
                                            className={`w-[49%] rounded-md text-[18px] py-2  px-[10px] ${Border} shadow-[4px_5px_6px_#00000029] `}
                                        />
                                        <input
                                            type="text"
                                            placeholder="Branch/Transition Code"
                                            // value={paymentData.BankAccount.branchCode}
                                            // onChange={(e) =>
                                            //     handleInputChange("BankAccount", "branchCode", e.target.value)
                                            // }
                                            className={`w-[49%] rounded-md text-[18px] py-2  px-[10px] ${Border} shadow-[4px_5px_6px_#00000029] `}
                                        />
                                    </div>
                                    <input
                                        type="text"
                                        placeholder="Account Number"
                                        // value={paymentData.BankAccount.accountNumber}
                                        // onChange={(e) =>
                                        //     handleInputChange("BankAccount", "accountNumber", e.target.value)
                                        // }
                                        className={`w-full rounded-md text-[18px] py-2  px-[10px] ${Border} shadow-[4px_5px_6px_#00000029] `}
                                    />
                                </div>
                            )}
                        </div>
                </div>

                <div className="hidden lg:w-[40%] lg:flex flex-col gap-[10px]">
                    <p className="text-[22px] text-[#000000] font-semibold mt-[10px]">Selected Plan</p>

                    {selectedPackageData && (
                        <div
                        key={selectedPackageData.PackageId}
                        className={`w-[450px] h-[800px] lg:h-[800px] rounded-[20px] pl-[30px] pt-[10px] pr-[30px] flex flex-col gap-[15px] ${
                            selectedPackage === selectedPackageData.PackageId
                            ? `bg-[${selectedPackageData.bgColor}] text-[${selectedPackageData.textColor}]`
                            : `bg-[${selectedPackageData.bgColor}] text-[${selectedPackageData.textColor}]`
                        }`}
                        style={{ border: "1px solid #BCBCBC" }}
                        >
                        {/* Pricing */}
                        <div className="w-full flex flex-col gap-[10px] mt-[10px]">
                            <div className="w-full flex items-center gap-[15px]">
                                <p
                                className={`text-[30px] font-semibold relative before:content-[''] before:absolute before:top-1/2 before:left-0 before:w-full before:h-[2px] before:-translate-y-1/2 ${
                                    selectedPackage === selectedPackageData.PackageId
                                    ? `text-[${selectedPackageData.bgColorSelected}] before:bg-[${selectedPackageData.bgColorSelected}]`
                                    : `text-[${selectedPackageData.bgColorSelected}] before:bg-[${selectedPackageData.bgColorSelected}]`
                                }`}
                                >
                                {/* {selectedPackageData.originalPrice} */}
                                {InstituteData.package.PackageType === "Monthly" ? selectedPackageData.originalPrice : selectedPackageData.originalAnnualPrice} 
                                </p>
                                <p className="text-[22px] font-semibold">
                                {/* {selectedPackageData.annualDiscount} */}
                                {InstituteData.package.PackageType === "Monthly" ? selectedPackageData.monthlyDiscount : selectedPackageData.annualDiscount} 
                                </p>
                            </div>
                            <p
                                className={`text-[50px] font-semibold ${
                                    selectedPackage === selectedPackageData.PackageId
                                    ? `text-[${selectedPackageData.bgColorSelected}]`
                                    : `text-[${selectedPackageData.bgColorSelected}]`
                                }`}
                                >
                                {/* {selectedPackageData.price} */}
                                {InstituteData.package.PackageType === "Monthly" ? selectedPackageData.price : selectedPackageData.AnnualPrice} 
                                </p>
                        </div>
                        
                        {/* Header */}
                        <div className="flex items-center gap-[20px]">
                            {/* <img
                            src={
                                selectedPackage === selectedPackageData.PackageId
                                ? selectedPackageData.image
                                : selectedPackageData.image
                            }
                            alt={selectedPackageData.InstitutePackageName}
                            /> */}
                            <img
                            src={selectedPackage === selectedPackageData.PackageId ? `${BaseUrl}/api/images/InstitutePackages?url=${selectedPackageData.image}` : `${BaseUrl}/api/images/InstitutePackages?url=${selectedPackageData.image}`}
                            alt={selectedPackageData.InstitutePackageName}
                            />
                            <p className="text-[40px] lg:text-[50px] font-semibold leading-[50px]">
                            {selectedPackageData.InstitutePackageName}
                            </p>
                        </div>

                        {/* Features */}
                        {selectedPackageData.features.map((feature, index) => (
                            <div
                            key={index}
                            className="flex items-center gap-[20px] mt-[10px]"
                            >
                            <div
                                className={`w-[30px] h-[30px] rounded-full flex justify-center items-center`}
                                style={{ backgroundColor: selectedPackageData.checkBoxBg }}
                            >
                                <DoneIcon
                                color="inherit"
                                style={{ color: selectedPackageData.checkBoxTick }}
                                />
                            </div>
                            <p
                                className={`text-[18px] font-semibold }`}
                            >
                                {feature}
                            </p>
                            </div>
                        ))}

                    <div className="w-full flex justify-between">
                            <p className="text-[22px] font-semibold">Compensation Performance :</p>
                            <p className="text-[22px] font-semibold">15%</p>
                    </div>

                    <div className="w-full flex justify-between">
                        <p className="text-[22px] font-semibold">Package Renewal Date:</p>
                        <p className="text-[22px] font-semibold">{renewalDate || "N/A"}</p>
                   </div>

                        </div>
                    )}

                    <p className="text-[22px] text-[#000000] font-semibold mt-[10px]">Grace Period & Activation Fee</p>

                    <p className="text-[16px] text-[#404040] w-[450px]">A grace period of 14 days is granted following the plan's expiry date. If the plan is renewed within this period, no activation fee will be charged. However, if the plan is not renewed within the grace period, an activation fee may apply and will be automatically deducted upon reactivation.</p>

                    {errors.autoDeduction && <span className="text-[#FF0000]"> {errors.autoDeduction}</span>}
                    <div className="w-full flex items-center gap-[15px]">
                        <input
                            type="checkbox"
                            checked={InstituteData.paymentInfo.autoDeduction}
                            onChange={handleAutoDeductionChange}
                            className="w-[15px] h-[15px] cursor-pointer mt-[3px]"
                        />
                        <p className="text-[18px] text-[#52A9FF]">Auto Deduction</p>
                    </div>

                </div>
            </div>

            {isUpdationFailedPopup && (
                <ReuseablePopup
                setShowPopup={setIsUpdationFailedPopup}
                heading="Oops!"
                text={errorMessageText}
                btnText="Back"
                onClick={() => setIsUpdationFailedPopup(false)} // <-- Add this line
                imageSrc={errorMessageImage} // ✅ Dynamic image source
                />
            )}
        </div>
    </div>
)
}

export default PaymentCheckout;


{/* <div className="w-full flex justify-center gap-[40px]">
                <div className="w-full lg:w-[50%] px-[30px] py-[20px] flex flex-col gap-[15px]">
                        
                        <p className="text-[22px] text-[#000000] font-semibold ">Payment Method</p>
                        
                        {errors.paymentMethod && <span className="text-[#FF0000]"> {errors.paymentMethod}</span>}
                        {errors.paymentSuccessful && <span className="text-[#FF0000]"> {errors.paymentSuccessful}</span>}
                        <div className="w-full flex flex-col gap-[15px] px-[15px] py-[10px] bg-[#FFFFFF] rounded-[8px] shadow-[4px_5px_6px_#00000029] overflow-hidden"
                            style={{border:"1px solid #E8E8E8"}}>
                            <div className="w-full flex items-center justify-between">
                                <div>
                                    <input
                                        type="radio"
                                        id="paypal"
                                        name="paymentMethod"
                                        value="paypal"
                                        onChange={handlePaymentMethodChange}
                                        className="mr-2"
                                    />
                                    <label htmlFor="paypal" className="text-[18px] text-[#707070]">
                                        PayPal
                                    </label>
                                </div>
                                <div>
                                    <img src={Paypal} alt="Paypal" className="h-[30px] w-[100px] object-contain" />
                                </div>
                            </div>
                            {selectedPaymentMethod === "paypal" && (
                                <div className="w-full flex justify-center items-center">
                                    <div className="w-[50%]">
                                        <PaypalCheckoutBtn
                                            PayPalButton={PayPalButton}
                                            currency="USD"
                                            dispatch={dispatch}
                                            Package={selectedPackageData.price}
                                            setInstituteData={setInstituteData}
                                            discount={discount}
                                            InstituteData={InstituteData}
                                            handleSubmit={handleSubmit}
                                        /> 
                                    </div>
                                </div>
                            )}
                        </div>

                        <div className="w-full flex flex-col px-[15px] py-[15px] bg-[#FFFFFF] rounded-[8px] shadow-[4px_5px_6px_#00000029]"
                            style={{border:"1px solid #E8E8E8"}}>
                            <div className="w-full flex items-center justify-between">
                                <div>
                                    <input
                                        type="radio"
                                        id="creditcard"
                                        name="paymentMethod"
                                        value="creditcard"
                                        onChange={handlePaymentMethodChange}
                                        className="mr-2"
                                    />
                                    <label htmlFor="Credit Card" className="text-[18px] text-[#707070]">
                                    Credit Card / Debit Card
                                    </label>
                                </div>
                                <div>
                                    <img src={CreditCard} alt="CreditCard" />
                                </div>
                            </div>

                            {selectedPaymentMethod === "creditcard" && (
                                <div className="mt-[10px] ">
                                    <CardElement
                                        options={{
                                            style: {
                                                base: {
                                                    fontSize: "18px",
                                                    padding: "10px",
                                                    color: "#424770",
                                                    backgroundColor: "white",
                                                    "::placeholder": { color: "#aab7c4" },
                                                },
                                                invalid: { color: "#9e2146" },
                                            },
                                        }}
                                    />
                                    <div className="w-full flex justify-end">
                                        <button disabled={!stripe} className="bg-[#A1A3EF] p-3" style={{ marginTop: "10px" }} onClick={handleCardPaymentSubmit}>
                                            {loading ? "Processing..." : `Pay ${discountedPrice}`}
                                        </button>
                                        
                                    </div>
                                        {error && <p style={{ color: "red" }}>{error}</p>}
                                        {paymentSuccess && <p style={{ color: "green" }}>Payment successful!</p>}
                                </div>
                            )}
                        </div>

                        <div className="w-full flex flex-col px-[15px] py-[15px] bg-[#FFFFFF] rounded-[8px] shadow-[4px_5px_6px_#00000029]"
                            style={{border:"1px solid #E8E8E8"}}>
                            <div className="w-full flex items-center justify-between">
                                <div>
                                    <input
                                        type="radio"
                                        id="BankAccount"
                                        name="paymentMethod"
                                        value="BankAccount"
                                        onChange={handlePaymentMethodChange}
                                        className="mr-2"
                                    />
                                    <label htmlFor="Bank Account" className="text-[18px] text-[#707070]">
                                        Bank Account
                                    </label>
                                </div>
                                <div>
                                    <img src={BankTransfer} alt="BankTransfer" className="h-[30px]" />
                                </div>
                            </div>
                            {selectedPaymentMethod === "BankAccount" && (
                                <div className="mt-[10px] flex flex-col gap-[10px]">
                                    <input
                                        type="text"
                                        placeholder="Bank Name"
                                        // value={paymentData.BankAccount.bankName}
                                        // onChange={(e) =>
                                        //     handleInputChange("BankAccount", "bankName", e.target.value)
                                        // }
                                        className={`w-full rounded-md text-[18px] py-2  px-[10px] ${Border} shadow-[4px_5px_6px_#00000029] `}
                                    />
                                    <input
                                        type="text"
                                        placeholder="Account Holder's Name"
                                        // value={paymentData.BankAccount.accountHolderName}
                                        // onChange={(e) =>
                                        //     handleInputChange("BankAccount", "accountHolderName", e.target.value)
                                        // }
                                        className={`w-full rounded-md text-[18px] py-2  px-[10px] ${Border} shadow-[4px_5px_6px_#00000029] `}
                                    />
                                    <div className="flex gap-[20px]">
                                        <input
                                            type="text"
                                            placeholder="Bank/Institute Code"
                                            // value={paymentData.BankAccount.bankCode}
                                            // onChange={(e) =>
                                            //     handleInputChange("BankAccount", "bankCode", e.target.value)
                                            // }
                                            className={`w-[49%] rounded-md text-[18px] py-2  px-[10px] ${Border} shadow-[4px_5px_6px_#00000029] `}
                                        />
                                        <input
                                            type="text"
                                            placeholder="Branch/Transition Code"
                                            // value={paymentData.BankAccount.branchCode}
                                            // onChange={(e) =>
                                            //     handleInputChange("BankAccount", "branchCode", e.target.value)
                                            // }
                                            className={`w-[49%] rounded-md text-[18px] py-2  px-[10px] ${Border} shadow-[4px_5px_6px_#00000029] `}
                                        />
                                    </div>
                                    <input
                                        type="text"
                                        placeholder="Account Number"
                                        // value={paymentData.BankAccount.accountNumber}
                                        // onChange={(e) =>
                                        //     handleInputChange("BankAccount", "accountNumber", e.target.value)
                                        // }
                                        className={`w-full rounded-md text-[18px] py-2  px-[10px] ${Border} shadow-[4px_5px_6px_#00000029] `}
                                    />
                                </div>
                            )}
                        </div>

                        {promoMessage && <span className="text-[#FF0000]"> {promoMessage}</span>}
                        {promoSuccessMessage && <span className="text-[#008000]"> {promoSuccessMessage}</span>}

                        <div
                            className={`w-full rounded-[20px] bg-[#F7F7F7] mt-[10px] p-[20px] flex flex-col gap-[15px] `}
                            style={{ border: "1px solid #BCBCBC" }}
                            >
                                <p className="text-[22px] font-semibold text-[#000000]">Apply Promo Code</p>
                                <div className="w-full flex gap-[20px]">
                                <input
                                    type="text"
                                    id="Promo Code"
                                    name="Promo Code"
                                    value={promoCode}
                                    onChange={(e) => setPromoCode(e.target.value)}
                                    placeholder="Promo Code"
                                    className={`w-full rounded-[5px] py-[10px] px-[10px] ${Border} shadow-md`}
                                />

                                <button
                                className={`w-[130px] cursor-pointer rounded-[8px] border-none py-3 text-[16px] text-white xl:py-2 xl:text-[18px] 2xl:text-base bg-[#A1A3EF]`}
                                onClick={handleApplyPromoCode}
                                >
                                    Apply
                                </button>

                                </div>
                        </div>

                        <p className="text-[22px] text-[#000000] font-semibold mt-[10px]">Order Summary</p>

                        <div className="w-full flex flex-col gap-[10px] px-[15px] py-[15px] bg-[#F7F7F7] rounded-[20px] shadow-[4px_5px_6px_#00000029]"
                        style={{
                                    border: "1px solid #707070"
                                }}>
                                <p className="text-[18px] text-[#A7A7A7] pb-[5px]"
                                style={{
                                    borderBottom: "0.5px solid #707070"
                                }}>Commercial License & All-access pass/Monthly</p>
                                <p className="text-[22px] text-[#000000] pb-[10px] font-bold"
                                style={{
                                    borderBottom: "0.5px solid #707070"
                                }}>  {discountedPrice} </p>
                                <p className="text-[18px] text-[#A7A7A7] pb-[5px]">Basic Plan.</p>
                        </div>

                        {errors.captcha && <span className="text-[#FF0000]"> {errors.captcha}</span>}
                        <div className="w-full mt-[10px]">
                            <ReCAPTCHA
                                sitekey="6Lecb_IoAAAAANjflXMmXPZiBMaU0clxSmxPG9f9"
                                onChange={onChange}
                            />
                        </div>

                        <p className="text-[16px] text-[#404040] mt-[15px]">In return for this content, I agree to Vehicle Learning Innovation(VLI), Meliorist contacting me (including by email, SMS, Phone) about this and other subject matter matching my interests. I understand that I can opt-out at any time by clicking 'unsubscribe' on emails or contacting (Vehicle Learning Innovation(VLI), Meliorist) Informa as set out in our Privacy Policy.</p>
                    
                        {errors.agreedToTerms && <span className="text-[#FF0000]"> {errors.agreedToTerms}</span>}
                        <div className="w-full flex items-center gap-[15px]">
                        <input
                            type="checkbox"
                            checked={InstituteData.paymentInfo.agreedToTerms}
                            onChange={handleAgreementChange}
                            className="w-[15px] h-[15px] cursor-pointer mt-[3px]"
                        />
                            <p className="text-[18px] text-[#52A9FF]">I Agree</p>
                        </div>

                        <button
                                className={`w-[130px] cursor-pointer rounded-[8px] border-none py-3 text-[16px] text-white xl:py-2 xl:text-[18px] 2xl:text-base bg-[#A1A3EF]`}
                                onClick={() => {
                                    if (validateFields()) {
                                        handleSubmit()
                                    }
                                }} 
                            >
                                Confirm
                        </button>
                </div>

                <div className="hidden lg:w-[40%] lg:flex flex-col gap-[20px]">
                    {selectedPackageData && (
                        <div
                        key={selectedPackageData.id}
                        className={`w-[450px] h-[800px] lg:h-[800px] rounded-[20px] pl-[30px] pt-[10px] pr-[30px] flex flex-col gap-[15px] ${
                            selectedPackage === selectedPackageData.id
                            ? `bg-[${selectedPackageData.bgColor}] text-[${selectedPackageData.textColor}]`
                            : `bg-[${selectedPackageData.bgColor}] text-[${selectedPackageData.textColor}]`
                        }`}
                        style={{ border: "1px solid #BCBCBC" }}
                        >
                        <div className="w-full flex flex-col gap-[10px] mt-[10px]">
                            <div className="w-full flex items-center gap-[15px]">
                                <p
                                className={`text-[30px] font-semibold relative before:content-[''] before:absolute before:top-1/2 before:left-0 before:w-full before:h-[2px] before:-translate-y-1/2 ${
                                    selectedPackage === selectedPackageData.id
                                    ? `text-[${selectedPackageData.bgColorSelected}] before:bg-[${selectedPackageData.bgColorSelected}]`
                                    : `text-[${selectedPackageData.bgColorSelected}] before:bg-[${selectedPackageData.bgColorSelected}]`
                                }`}
                                >
                                {selectedPackageData.originalPrice}
                                </p>
                                <p className="text-[22px] font-semibold">
                                {selectedPackageData.annualDiscount}
                                </p>
                            </div>
                            <p
                                className={`text-[50px] font-semibold ${
                                    selectedPackage === selectedPackageData.id
                                    ? `text-[${selectedPackageData.bgColorSelected}]`
                                    : `text-[${selectedPackageData.bgColorSelected}]`
                                }`}
                                >
                                {selectedPackageData.price}
                                </p>
                        </div>
                        
                        <div className="flex items-center gap-[20px]">
                            <img
                            src={
                                selectedPackage === selectedPackageData.id
                                ? selectedPackageData.image
                                : selectedPackageData.image
                            }
                            alt={selectedPackageData.name}
                            />
                            <p className="text-[40px] lg:text-[50px] font-semibold leading-[50px]">
                            {selectedPackageData.name}
                            </p>
                        </div>

                        {selectedPackageData.features.map((feature, index) => (
                            <div
                            key={index}
                            className="flex items-center gap-[20px] mt-[10px]"
                            >
                            <div
                                className={`w-[30px] h-[30px] rounded-full flex justify-center items-center`}
                                style={{ backgroundColor: selectedPackageData.checkBoxBg }}
                            >
                                <DoneIcon
                                color="inherit"
                                style={{ color: selectedPackageData.checkBoxTick }}
                                />
                            </div>
                            <p
                                className={`text-[18px] font-semibold }`}
                            >
                                {feature}
                            </p>
                            </div>
                        ))}

                    <div className="w-full flex justify-between">
                            <p className="text-[22px] font-semibold">Compensation Performance :</p>
                            <p className="text-[22px] font-semibold">15%</p>

                    </div>

                        </div>
                    )}
                </div>
            </div> */}